import React, { useState } from 'react'
import useDebounce from '../../hooks/useDebounce'
import '../../styling/SearchBar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faFilter } from '@fortawesome/free-solid-svg-icons'

const SearchBar = ({ onSearch, onFilterChange }) => {
  const [searchValue, setSearchValue] = useState('')
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [activeFilters, setActiveFilters] = useState([])

  const debouncedSearch = useDebounce(searchValue, 300)

  React.useEffect(() => {
    onSearch(debouncedSearch.trim())
  }, [debouncedSearch, onSearch])

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value)
  }

  const handleFilterChange = (filters) => {
    setActiveFilters(filters)
    onFilterChange(filters)
  }

  const toggleFilterPanel = () => {
    setIsFilterOpen(!isFilterOpen)
  }

  const searchContainerStyle = {
    width: '100%',
    padding: '10px 15px',
    marginBottom: '0',
    position: 'relative',
    borderBottom: '1px solid #f0f0f0',
    backgroundColor: '#fff'
  }

  const searchInputWrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  }

  const searchInputContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flex: 1,
    border: '1px solid #e8e8e8',
    borderRadius: '4px',
    padding: '5px 10px',
    backgroundColor: '#f5f5f5'
  }

  const searchInputStyle = {
    border: 'none',
    outline: 'none',
    width: '100%',
    padding: '6px 5px',
    fontSize: '14px',
    backgroundColor: 'transparent'
  }

  const searchIconStyle = {
    marginRight: '8px',
    color: '#999'
  }

  const filterButtonStyle = {
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '10px',
    fontSize: '16px',
    color: '#666',
    position: 'relative',
    cursor: 'pointer'
  }

  const clearButtonStyle = {
    border: 'none',
    background: 'none',
    padding: '0 5px',
    fontSize: '16px',
    color: '#999',
    cursor: 'pointer'
  }

  const filterPanelStyle = {
    width: '100%',
    padding: '8px 15px',
    backgroundColor: '#f9f9f9',
    borderBottom: '1px solid #eaeaea',
    display: 'flex',
    flexDirection: 'column'
  }

  const filterTitleStyle = {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '8px',
    color: '#333'
  }

  const filterOptionsStyle = {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px'
  }

  const checkboxLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: '#555',
    marginRight: '10px'
  }

  const checkboxStyle = {
    marginRight: '5px'
  }

  const filterActionsStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '5px'
  }

  const clearAllButtonStyle = {
    padding: '5px 8px',
    border: '1px solid #ccc',
    backgroundColor: 'transparent',
    borderRadius: '4px',
    fontSize: '12px',
    color: '#666',
    cursor: 'pointer'
  }

  const applyButtonStyle = {
    padding: '5px 15px',
    border: '1px solid #1890ff',
    backgroundColor: '#1890ff',
    borderRadius: '4px',
    fontSize: '12px',
    color: 'white',
    cursor: 'pointer'
  }

  return (
    <div className='cs-search' style={searchContainerStyle}>
      <div className='cs-search__input-wrapper' style={searchInputWrapperStyle}>
        <div className='cs-search__input-container' style={searchInputContainerStyle}>
          <FontAwesomeIcon icon={faSearch} style={searchIconStyle} />
          <input
            type='text'
            className='cs-search__input'
            placeholder='Search tests...'
            value={searchValue}
            onChange={handleSearchChange}
            style={searchInputStyle}
          />
          {searchValue && (
            <button className='cs-search__clear-btn' onClick={() => setSearchValue('')} style={clearButtonStyle}>
              ✕
            </button>
          )}
        </div>
        <button
          className={`cs-search__filter-btn ${activeFilters.length ? 'active' : ''}`}
          onClick={toggleFilterPanel}
          style={filterButtonStyle}
        >
          <FontAwesomeIcon icon={faFilter} />
          {activeFilters.length > 0 && <span className='cs-search__filter-count'>{activeFilters.length}</span>}
        </button>
      </div>

      {isFilterOpen && (
        <div className='cs-search__filter-panel' style={filterPanelStyle}>
          <div style={filterTitleStyle}>Filter Tests</div>
          <div className='cs-search__filter-options' style={filterOptionsStyle}>
            <label style={checkboxLabelStyle}>
              <input
                type='checkbox'
                style={checkboxStyle}
                checked={activeFilters.includes('popular')}
                onChange={() => {
                  const newFilters = activeFilters.includes('popular')
                    ? activeFilters.filter((f) => f !== 'popular')
                    : [...activeFilters, 'popular']
                  handleFilterChange(newFilters)
                }}
              />
              Popular Tests
            </label>
            <label style={checkboxLabelStyle}>
              <input
                type='checkbox'
                style={checkboxStyle}
                checked={activeFilters.includes('new')}
                onChange={() => {
                  const newFilters = activeFilters.includes('new')
                    ? activeFilters.filter((f) => f !== 'new')
                    : [...activeFilters, 'new']
                  handleFilterChange(newFilters)
                }}
              />
              New Tests
            </label>
          </div>
          <div className='cs-search__filter-actions' style={filterActionsStyle}>
            <button
              className='cs-search__filter-clear'
              onClick={() => handleFilterChange([])}
              style={clearAllButtonStyle}
            >
              Clear All
            </button>
            <button className='cs-search__filter-apply' onClick={() => setIsFilterOpen(false)} style={applyButtonStyle}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchBar
